import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { firebaseConfigJson } from "../firebaseConfigJson";

const app = initializeApp(firebaseConfigJson);
export const db = getDatabase(app);
